import type { SelectOption } from '@/types';
import type { GiftTag } from '../model';
import { GIFT_TAGS } from '../model';

/**
 * Конфигурация меток подарка
 */

/**
 * Дефолтное значение метки подарка для новых желаний
 */
export const DEFAULT_GIFT_TAG: GiftTag = 'none';

export type GiftTagOption = SelectOption & {
  id: GiftTag;
};

/**
 * Полная конфигурация меток подарка - единственный source of truth
 */
export const GIFT_TAG_CONFIG: Record<GiftTag, { 
  emoji: string; 
  labelKey: string; // i18n ключ
  bgColor: string; 
  textColor: string;
  // Tailwind классы для Badge компонента
  bgClass: string;
  textClass: string;
}> = {
  'none': { 
    emoji: '', 
    labelKey: 'wishlist:wishlist.giftTags.none', 
    bgColor: 'var(--color-muted)', 
    textColor: 'var(--color-muted-foreground)',
    bgClass: 'bg-muted',
    textClass: 'text-muted-foreground'
  },
  'really-want': { 
    emoji: '🔥', 
    labelKey: 'wishlist:wishlist.giftTags.reallyWant', 
    bgColor: 'var(--color-primary-light)', 
    textColor: 'var(--color-primary)',
    bgClass: 'bg-primary-light',
    textClass: 'text-primary'
  },
  'would-be-nice': { 
    emoji: '👍', 
    labelKey: 'wishlist:wishlist.giftTags.wouldBeNice', 
    bgColor: 'var(--color-blue-light)', 
    textColor: 'var(--color-blue-dark)',
    bgClass: 'bg-blue-light',
    textClass: 'text-blue-dark'
  },
  'thinking': { 
    emoji: '🤔', 
    labelKey: 'wishlist:wishlist.giftTags.thinking', 
    bgColor: 'var(--color-yellow-light)', 
    textColor: 'var(--color-yellow-dark)',
    bgClass: 'bg-yellow-light',
    textClass: 'text-yellow-dark'
  },
  'buy-myself': { 
    emoji: '💰', 
    labelKey: 'wishlist:wishlist.giftTags.buyMyself', 
    bgColor: 'var(--color-green-light)', 
    textColor: 'var(--color-green-dark)',
    bgClass: 'bg-green-light',
    textClass: 'text-green-dark'
  },
};

/**
 * Опции для SelectList - генерируются из GIFT_TAG_CONFIG (DRY)
 * Порядок элементов из GIFT_TAGS константы (SSOT)
 */
export const GIFT_TAG_OPTIONS: readonly GiftTagOption[] = GIFT_TAGS.map((id) => {
  const config = GIFT_TAG_CONFIG[id];
  return {
    id,
    label: config.labelKey,
    icon: config.emoji || undefined, // Не передаём пустую строку как icon
  };
});

/**
 * Стили для меток подарка (для Badge компонента) - генерируются из GIFT_TAG_CONFIG (DRY)
 */
export const GIFT_TAG_STYLES = Object.fromEntries(
  Object.entries(GIFT_TAG_CONFIG).map(([id, config]) => [
    id, 
    { bg: config.bgClass, text: config.textClass }
  ])
) as Record<GiftTag, { bg: string; text: string }>;